import React from 'react';
import PropTypes from 'prop-types';
import get from "lodash/get";
import map from "lodash/map";
import isNull from "lodash/isNull";
import isUndefined from "lodash/isUndefined";
import Accordion from '../accordion/accordion';
import CollapsingDescription from '../elements-description/CollapsingDescription';
import { ReadMoreText } from '../elements-container/read-more-text-toggle';
import { defineMessages } from 'react-intl';

// NOTE: any changes to the ProductionFAQ questions
// will need to be changed in the analytics call as well
export const FAQSections = ({ label, icon, faqFn, faqData, intl }) => {
  const faqKeys = Object.keys(faqFn());
  // need to revisit the alt img intl for this
  const altText = defineMessages({
    icon: {
      id: 'listing.production_faq.accordion_image',
      defaultMessage: 'icon'
    }
  });

  return (
    <Accordion
      header={
        <div className="flex middle">
          <div className="img-container">
            <img
              src={`/web-listings/assets/images/${icon}.svg?v=rb`}
              alt={intl.formatMessage(altText.icon)}
            />
          </div>
          <div>
            <h6 className="padding-xs-top padding-xs-bottom">
              {label}
            </h6>
          </div>
        </div>
      }
      onOpenCallback={() => {
        analyticsIntegrations.trackEvent('Listing section expanded', {
          listing_id: faqData.listingID,
          section: label
        });
      }}
    >
      {
        map(faqKeys, (key) => {
          const answer = get(faqData, key);
          const faqHash = faqFn(answer, intl);
          const returnedLabel = get(faqHash, [key, 'label'], '');
          const label = 'object' === typeof returnedLabel
            ? intl.formatMessage(returnedLabel, { answer: answer })
            : returnedLabel;
          const description = get(faqHash, [key, 'description'], '');

          if (isUndefined(answer) || isNull(answer) || '' === answer) {
            return null;
          }

          // zeros are acceptable answers
          if (!label && !description) {
            return null;
          }

          return (
            <div className="faq-body flex" key={key}>
              <div className="img-container">&nbsp;</div>
              <div className="flex-basis-90">
                { label && <div className="faq-label heavier">{label}</div> }
                {
                  description && <ReadMoreText
                    text={description}
                    linesToDisplay={2}
                    textClass="text-gray-600 description"
                    linkStyling="text-gray-600"
                  />
                }
              </div>
            </div>
          );
        })
      }
    </Accordion>
  );
};
